import { FailuresById } from '../models/IMetricDataList';
import { MetricsDataRequestFailedAction, MetricsDataActionTypes } from './ActionTypes';

export const metricsDataRequestFailed = (failuresById: FailuresById): MetricsDataRequestFailedAction => {
  return {
    type: MetricsDataActionTypes.REQUEST_FAILED,
    failuresById,
  };
};
